/**
 * The list of all countries with their 2 digit codes (ISO 3166-2)
 *
 * @see http://data.okfn.org/data/core/country-list
 */
export default [{
    "name": "Belgium",
    "code": "BE"
}, {
    "name": "Canada",
    "code": "CA"
}, {
    "name": "France",
    "code": "FR"
}, {
    "name": "Germany",
    "code": "DE"
}, {
    "name": "Ireland",
    "code": "IE"
}, {
    "name": "Netherlands",
    "code": "NL"
}, {
    "name": "United Arab Emirates",
    "code": "AE"
}, {
    "name": "United Kingdom",
    "code": "GB"
}, {
    "name": "United States",
    "code": "US"
}];
